// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__16Rbs","alertIcon":"ConfirmModal_alertIcon__1DeI2"};